/* eslint-disable class-methods-use-this */
import { createMessenger } from '@userlike/messenger';
import AnalyticsHelper from './analytics-helper';

export default class ChatBotServices {
    constructor(el) {
        if (el) {
            this.el = el;
            this.chatWrapper = this.el.querySelector('.start-chat-window');
            this.chatButton = this.el.querySelector('.start-chat-button');
            this.widgetKey = this.el.dataset.widgetkey;
            if (!this.el.classList.contains('initialized')) {
                this.init();
            }
        }
    }

    init() {
        async function createApi(widgetKey) {
            const result = await createMessenger({
                version: 1,
                widgetKey,
            });
            const { api } = result.value;
            return api;
        }

        const userlike = createApi(this.widgetKey);

        userlike.then((messenger) => {
            messenger.mount()
                .then(() => messenger.setVisibility({
                    main: true,
                    button: true,
                    notifications: false,
                }));

            this.chatWrapper?.classList.remove('hidden');
        });

        this.startChat = () => {
            userlike.then((m) => m.maximize());
        };

        this.chatButton?.addEventListener(
            'click', (e) => {
                this.startChat(e);
                this.analyticsPush();
            },
        );

        this.el.classList.add('initialized');
    }

    analyticsPush() {
        AnalyticsHelper.push({
            event: 'live_chat',
            eventCategory: 'live_chat',
            eventAction: 'live chat',
            eventLabel: 'cars|live chat|start chat|internal|bottom|#',
            actionType: 'live chat',
            businessUnit: 'cars',
            moduleName: 'live chat',
            clickText: 'start chat',
            clickType: 'internal',
            destinationURL: '#',
            modelSelected: '',
            inPageLocation: 'bottom',
        });
    }
}
